{
	"Features Practice Area": {
		"Feature 01": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"componentId": {
					"translations": {},
					"value": "Features Practice Area Aside"
				},
				"containerClass": {
					"translations": {},
					"value": "col-span-1 h-full md:sticky md:top-0 md:max-h-[1500px] md:overflow-y-scroll md:scroll-smooth"
				},
				"notes": {
					"translations": {},
					"value": "md:max-h is going to fit content in the sidebar and still make is stick to the top.  the problem is you gotta do it for all articles where toc varies"
				}
			}
		},
		"Feature 02": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"componentId": {
					"translations": {},
					"value": "MarkedContent Practice Area"
				},
				"containerClass": {
					"translations": {},
					"value": "col-span-1 md:col-span-2 md:pb-[100vh] bg-base-300 p-2 sm:p-4 rounded-xl"
				}
			}
		},
		"classes": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"contentClass": {
					"translations": {},
					"value": "m-2 sm:m-4"
				},
				"featuresContainerClass": {
					"translations": {},
					"value": "grid grid-cols-1 gap-2 md:grid-cols-3 md:gap-4"
				},
				"otherClasses": {
					"translations": {},
					"value": "col-span-1 h-full md:sticky md:top-0 md:max-h-[1500px] md:overflow-y-scroll md:scroll-smooth md:pb-[100vh]"
				}
			}
		},
		"index": 0,
		"pageOrder": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "03"
		}
	},
	"Features Practice Area Aside": {
		"Feature 01": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"componentId": {
					"translations": {},
					"value": "TOC Practice Area"
				},
				"containerClass": {
					"translations": {},
					"value": "w-full bg-base-300 p-2 sm:p-4 rounded-xl"
				}
			}
		},
		"Feature 02": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"componentId": {
					"translations": {},
					"value": "RelatedArticles Practice Area"
				},
				"containerClass": {
					"translations": {},
					"value": "w-full bg-base-300 p-2 sm:p-4 rounded-xl"
				}
			}
		},
		"classes": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"contentClass": {
					"translations": {},
					"value": "my-0 py-0"
				},
				"featuresContainerClass": {
					"translations": {},
					"value": "grid grid-cols-1 gap-2 sm:gap-4"
				},
				"otherClasses": {
					"translations": {},
					"value": "w-full"
				}
			}
		},
		"index": 1
	},
	"Features Services Grid": {
		"classes": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"featureClass": {
					"translations": {},
					"value": "flex flex-wrap justify-center gap-2 sm:gap-4"
				},
				"featureContainerClass": {
					"translations": {},
					"value": "bg-linear-to-br from-base-300 via-transparent to-base-300 m-2 sm:m-4 p-2 sm:p-4 w-80"
				},
				"featuresContainerClass": {
					"translations": {},
					"value": "flex flex-wrap justify-center"
				},
				"imageClass": {
					"translations": {},
					"value": "h-48 object-contain mx-auto rounded"
				},
				"previewHeightClass": {
					"translations": {},
					"value": "h-24"
				}
			}
		},
		"docsCollection": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "services"
		},
		"index": 2,
		"order": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "03"
		}
	},
	"Head": {
		"index": 3,
		"order": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "01"
		},
		"title": {
			"permission": "Admin",
			"translations": {
				"ar": "مجالات الممارسة",
				"en": "Practice Areas",
				"en-GB": "Practice Areas",
				"en-US": "Practice Areas",
				"es": "Áreas de práctica",
				"es-419": "Áreas de práctica",
				"es-ES": "Áreas de práctica",
				"he": "תחומי עיסוק",
				"it": "Aree di competenza",
				"pl": "Obszary praktyki",
				"sw": "Maeneo ya Mazoezi",
				"tl": "Mga Lugar ng Pagsasanay",
				"vi": "Các lĩnh vực thực hành",
				"zh": "业务领域"
			},
			"type": "TextInput",
			"value": "Practice Areas"
		}
	},
	"Head Practice Area": {
		"docsCollection": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "services"
		},
		"index": 4,
		"pageOrder": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "01"
		}
	},
	"MarkedContent Practice Area": {
		"classes": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"containerClass": {
					"translations": {},
					"value": "w-full"
				}
			}
		},
		"docsCollection": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "services"
		},
		"index": 5
	},
	"PageBanner": {
		"bgImage": {
			"permission": "Admin",
			"type": "Image",
			"value": {
				"description": {
					"translations": {
						"ar": "جسر البرج الذهبي ونهر سكرامنتو في سكرامنتو، كاليفورنيا، تم تصويرهما من منتزه ريفر ووك ليلاً مع وجود النجوم في السماء.",
						"en": "Gold Tower Bridge and Sacramento River in Sacramento, California, photographed from River Walk Park at night with stars in the sky.",
						"en-GB": "Gold Tower Bridge and Sacramento River in Sacramento, California, photographed from River Walk Park at night with stars in the sky.",
						"en-US": "Gold Tower Bridge and Sacramento River in Sacramento, California, photographed from River Walk Park at night with stars in the sky.",
						"es": "El Puente de la Torre de Oro y el río Sacramento en Sacramento, California, fotografiados desde el River Walk Park de noche con estrellas en el cielo.",
						"es-419": "El Puente de la Torre de Oro y el río Sacramento en Sacramento, California, fotografiados desde el River Walk Park de noche con estrellas en el cielo.",
						"es-ES": "El Puente de la Torre de Oro y el río Sacramento en Sacramento, California, fotografiados desde el River Walk Park de noche con estrellas en el cielo.",
						"he": "גשר מגדל הזהב ונהר סקרמנטו בסקרמנטו, קליפורניה, צולם מפארק ריבר ווק בלילה עם כוכבים בשמיים.",
						"it": "Il Gold Tower Bridge e il fiume Sacramento a Sacramento, California, fotografati dal River Walk Park di notte con le stelle nel cielo.",
						"pl": "Most Gold Tower Bridge i rzeka Sacramento w Sacramento w Kalifornii, sfotografowane nocą z River Walk Park na tle rozgwieżdżonego nieba.",
						"sw": "Daraja la Mnara wa Dhahabu na Mto Sacramento huko Sacramento, California, vilipigwa picha kutoka Hifadhi ya Mto Walk usiku na nyota angani.",
						"tl": "Ang Gold Tower Bridge at ang Sacramento River sa Sacramento, California, na kinunan ng litrato mula sa River Walk Park sa gabi kasama ang mga bituin sa kalangitan.",
						"vi": "Cầu Tháp Vàng và sông Sacramento ở Sacramento, California, được chụp từ công viên River Walk vào ban đêm với bầu trời đầy sao.",
						"zh": "加利福尼亚州萨克拉门托市的金塔桥和萨克拉门托河，照片拍摄于夜晚的河滨公园，天空繁星点点。"
					},
					"value": "Gold Tower Bridge and Sacramento River in Sacramento, California, photographed from River Walk Park at night with stars in the sky."
				},
				"downloadUrl": "https://firebasestorage.googleapis.com/v0/b/amber-bellante.firebasestorage.app/o/uploads%2Fpractice%20areas%2FPageBanner%2FbgImage%2Fshutterstock_2243996415-cropped.jpg?alt=media&token=ace4c029-6efc-4b5e-8020-514b1bcd81d5",
				"formattedSize": "567.15 KB",
				"height": 500,
				"name": "shutterstock_2243996415-cropped.jpg",
				"path": "uploads/practice areas/PageBanner/bgImage/shutterstock_2243996415-cropped.jpg",
				"query": "?as=run",
				"size": 580764,
				"type": "image/jpeg",
				"updated": "2026-03-04T04:17:04.646Z",
				"width": 1600
			}
		},
		"classes": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"bgImageClass": {
					"translations": {},
					"value": "opacity-20 grayscale"
				}
			}
		},
		"index": 6,
		"order": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "02"
		},
		"subtitle": {
			"permission": "Admin",
			"translations": {
				"ar": "مكتب المحامية آمبر بيلانتي",
				"en": "The Law Offices of Amber Bellante",
				"en-GB": "The Law Offices of Amber Bellante",
				"en-US": "The Law Offices of Amber Bellante",
				"es": "El bufete de abogados de Amber Bellante",
				"es-419": "El bufete de abogados de Amber Bellante",
				"es-ES": "El bufete de abogados de Amber Bellante",
				"he": "משרד עורכי הדין של אמבר בלנטה",
				"it": "Lo studio legale di Amber Bellante",
				"pl": "Kancelaria Adwokacka Amber Bellante",
				"sw": "Ofisi za Sheria za Amber Bellante",
				"tl": "Ang Mga Tanggapan ng Abogado ni Amber Bellante",
				"vi": "Văn phòng luật sư Amber Bellante",
				"zh": "安珀·贝兰特律师事务所"
			},
			"type": "TextInput",
			"value": "The Law Offices of Amber Bellante"
		},
		"title": {
			"permission": "Admin",
			"translations": {
				"ar": "مجالات الممارسة",
				"en": "Practice Areas",
				"en-GB": "Practice Areas",
				"en-US": "Practice Areas",
				"es": "Áreas de práctica",
				"es-419": "Áreas de práctica",
				"es-ES": "Áreas de práctica",
				"he": "תחומי עיסוק",
				"it": "Aree di competenza",
				"pl": "Obszary praktyki",
				"sw": "Maeneo ya Mazoezi",
				"tl": "Mga Lugar ng Pagsasanay",
				"vi": "Các lĩnh vực thực hành",
				"zh": "业务领域"
			},
			"type": "TextInput",
			"value": "Practice Areas"
		},
		"useMask": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "false"
		}
	},
	"PageBanner Practice Area": {
		"bgImage": {
			"permission": "Admin",
			"type": "Image",
			"value": {
				"description": {
					"translations": {
						"ar": "لقطة جوية بانورامية مقرّبة لمبنى الكابيتول بولاية كاليفورنيا في سكرامنتو نهاراً. 4K",
						"en": "Close-up panning aerial shot of the California State Capitol in Sacramento at daytime. 4K",
						"en-GB": "Close-up panning aerial shot of the California State Capitol in Sacramento at daytime. 4K",
						"en-US": "Close-up panning aerial shot of the California State Capitol in Sacramento at daytime. 4K",
						"es": "Primer plano de una toma aérea panorámica del Capitolio del Estado de California en Sacramento durante el día. 4K",
						"es-419": "Primer plano de una toma aérea panorámica del Capitolio del Estado de California en Sacramento durante el día. 4K",
						"es-ES": "Primer plano de una toma aérea panorámica del Capitolio del Estado de California en Sacramento durante el día. 4K",
						"he": "צילום אווירי מקרוב של בניין הקפיטול של מדינת קליפורניה בסקרמנטו בשעות היום. 4K",
						"it": "Ripresa aerea panoramica ravvicinata del Campidoglio dello Stato della California a Sacramento durante il giorno. 4K",
						"pl": "Zbliżenie na Kapitol Stanowy Kalifornii w Sacramento z lotu ptaka w ciągu dnia. 4K",
						"sw": "Picha ya karibu ya angani ya Capitol ya Jimbo la California huko Sacramento wakati wa mchana. 4K",
						"tl": "Malapitang kuha mula sa himpapawid ng California State Capitol sa Sacramento noong araw. 4K",
						"vi": "Cảnh quay cận cảnh từ trên cao tòa nhà Quốc hội bang California ở Sacramento vào ban ngày. Độ phân giải 4K.",
						"zh": "白天，从空中拍摄的加州州议会大厦（位于萨克拉门托）的特写镜头。4K"
					},
					"value": "Close-up panning aerial shot of the California State Capitol in Sacramento at daytime. 4K"
				},
				"downloadUrl": "https://firebasestorage.googleapis.com/v0/b/amber-bellante.firebasestorage.app/o/uploads%2Fpractice%20areas%2FPageBanner%20Practice%20Area%2FbgImage%2Fshutterstock_1092700045-first-frame.jpg?alt=media&token=4913d546-efa4-4ce5-af31-39c6bd36fd67",
				"formattedSize": "212.48 KB",
				"height": 500,
				"name": "shutterstock_1092700045-first-frame.jpg",
				"path": "uploads/practice areas/PageBanner Practice Area/bgImage/shutterstock_1092700045-first-frame.jpg",
				"query": "?as=run",
				"size": 217582,
				"type": "image/jpeg",
				"updated": "2026-01-30T14:08:11.188Z",
				"width": 1600
			}
		},
		"classes": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"bgImageClass": {
					"translations": {},
					"value": "w-full opacity-20 grayscale"
				},
				"subtitleClass": {
					"translations": {},
					"value": "pt-4 sm:pt-8"
				}
			}
		},
		"docsCollection": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "services"
		},
		"index": 7,
		"pageOrder": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "02"
		},
		"subtitle": {
			"permission": "Admin",
			"translations": {
				"ar": "مجالات الممارسة",
				"en": "Practice Areas",
				"en-GB": "Practice Areas",
				"en-US": "Practice Areas",
				"es": "Áreas de práctica",
				"es-419": "Áreas de práctica",
				"es-ES": "Áreas de práctica",
				"he": "תחומי עיסוק",
				"it": "Aree di competenza",
				"pl": "Obszary praktyki",
				"sw": "Maeneo ya Mazoezi",
				"tl": "Mga Lugar ng Pagsasanay",
				"vi": "Các lĩnh vực thực hành",
				"zh": "业务领域"
			},
			"type": "TextInput",
			"value": "Practice Areas"
		},
		"useMask": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "false"
		}
	},
	"RelatedArticles Practice Area": {
		"action": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"href": {
					"translations": {
						"ar": "/مجالات التدريب/",
						"en": "/practice-areas/",
						"en-GB": "/practice-areas/",
						"en-US": "/practice-areas/",
						"es": "/áreas-de-práctica/",
						"es-419": "/áreas-de-práctica/",
						"es-ES": "/áreas-de-práctica/",
						"he": "/תחומי-תרגול/",
						"it": "/aree-di-pratica/",
						"pl": "/obszary-praktyki/",
						"sw": "/maeneo-ya-mazoezi/",
						"tl": "/mga-lugar-ng-pagsasanay/",
						"vi": "/lĩnh vực thực hành/",
						"zh": "/实践领域/"
					},
					"value": "/practice-areas/"
				},
				"label": {
					"translations": {
						"ar": "عرض الكل",
						"en": "Show All",
						"en-GB": "Show All",
						"en-US": "Show All",
						"es": "Mostrar todo",
						"es-419": "Mostrar todo",
						"es-ES": "Mostrar todo",
						"he": "הצג הכל",
						"it": "Mostra tutto",
						"pl": "Pokaż wszystko",
						"sw": "Onyesha Zote",
						"tl": "Ipakita Lahat",
						"vi": "Hiển thị tất cả",
						"zh": "显示全部"
					},
					"value": "Show All"
				}
			}
		},
		"classes": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"actionClass": {
					"translations": {},
					"value": "btn btn-wide mx-auto mt-2 sm:mt-4 mx-auto hover-ripple px-8 sm:px-16 float-right"
				}
			}
		},
		"docsCollection": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "services"
		},
		"index": 8,
		"relatedArticleCategoryLabel": {
			"permission": "Admin",
			"translations": {
				"ar": "مجالات الممارسة",
				"en": "Practice Areas",
				"en-GB": "Practice Areas",
				"en-US": "Practice Areas",
				"es": "Áreas de práctica",
				"es-419": "Áreas de práctica",
				"es-ES": "Áreas de práctica",
				"he": "תחומי עיסוק",
				"it": "Aree di competenza",
				"pl": "Obszary praktyki",
				"sw": "Maeneo ya Mazoezi",
				"tl": "Mga Lugar ng Pagsasanay",
				"vi": "Các lĩnh vực thực hành",
				"zh": "业务领域"
			},
			"type": "TextInput",
			"value": "Practice Areas"
		}
	},
	"TOC Practice Area": {
		"docsCollection": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "services"
		},
		"index": 9
	}
}